<!--
 * @Author       : 四川华西绿舍建材有限公司
 * @Date         : 2025-10-10 09:43:25
 * @LastEditTime : 2025-10-29 10:03:18
 * @LastEditors  : yangxr
 * @Description  : 计划明细
 * @FilePath     : \icps_fb\src\views\platform\ICPS\smart\schedul\planDetail.vue
-->
<template>
  <div class="pages_content table">
    <el-container>
      <el-header>
        <breaDcrumb />
      </el-header>
      <el-main>
        <div>
          <div class="header_right" @click="showCardNav = !showCardNav">
            <div class="title">搜索</div>
            <div>
              <span v-show="!showCardNav">
                <i style="margin-right: 5px" class="el-icon-arrow-down"></i>
              </span>
              <span v-show="showCardNav">
                <i style="margin-right: 5px" class="el-icon-arrow-up"></i>
              </span>
            </div>
          </div>
          <div v-show="showCardNav" class="hr"></div>
          <el-collapse-transition>
            <div v-show="showCardNav">
              <div class="search">
                <span style="margin-left: 10px; margin-bottom: 10px; display: inline-block">
                  <span style="margin-right: 12px">订单状态</span>
                <el-select v-model="searchForm.orderStatus" style="width: 100px" placeholder="请选择">
                  <el-option v-for="(item, index) in oderStatusList" :key="index" :label="item.name" :value="item.value"
                    @click.native="changeOrderStatus(item)"></el-option>
                </el-select>
                </span>
                <span style="margin-left: 24px">
                  <span style="margin-right: 12px">站点名称</span>
                  <el-select ref="selection" v-model="searchForm.stationIds" multiple  style="width: 120px" filterable>
                    <el-option v-for="item in stationList" :key="item.id" :label="item.name" :value="item.id"></el-option>
                  </el-select>
                </span>
                <span style="margin-left: 10px; margin-bottom: 10px; display: inline-block">
                  <span style="margin-right: 5px">高级搜索：</span>
                  <el-input v-model="searchForm.productName" style="width: 150px" placeholder="请输入"
                    @keyup.enter.native="(tableParams.page = 1),gettableData()" />
                </span>
                <span style="margin-left: 10px; margin-bottom: 10px; display: inline-block">
                  <span style="margin-right: 5px">浇筑日期：</span>
                  <el-date-picker v-model="searchForm.proTimeRange" type="datetimerange" unlink-panels
                    value-format="yyyy-MM-dd HH:mm:ss" start-placeholder="开始时间" end-placeholder="结束时间"
                    @change="(tableParams.page = 1),gettableData()"></el-date-picker>
                </span>
                <el-button icon="el-icon-search" size="medium" class="bottom_all but1"
                  @click="(tableParams.page = 1), gettableData()">查 询</el-button>
                <el-button size="medium" class="bottom_all_two" style="margin-left: 12px" @click="init()">重 置</el-button>
              </div>
            </div>
          </el-collapse-transition>
          <div class="card">
            <div v-loading="tableLoading" class="card_info">
              <el-table :header-cell-style="{ background: '#f3f6f9' }" :cell-style="{ borderRight: 'none' }" border stripe
                style="width: 100%" :height="screenHeight - 450" :data="tableData" tooltip-effect="dark"
                :summary-method="getSummaries" show-summary>
                <template v-for="(item, index2) in table">
                <el-table-column v-if="item.status" :key="index2 + columKey" :label="item.label" :prop="item.prop"
                  :width="item.label == '发料' ? (isMaterialIssue ? '100' : '70') : item.width" :fixed="item.fixed"
                  :show-overflow-tooltip="item.label == '优先等级' || item.label == '在外车辆设置' ? false : true"
                  :align="item.label == '工程名称' || item.label == '浇筑部位' || item.label == '浇筑方式' || item.label == '产品名称' ? '' : 'center'">
                  <template slot-scope="scope">
                    <span v-if="item.label == '过磅照片' && showAll != 'table_1' && scope.$index != tableData.length - 1">
                      <el-button size="mini" class="bottom_one" @click="lookPicture(scope.row)">查看</el-button>
                    </span>
                    <span v-else-if="item.label == '开工' && showAll != 'table_1' && scope.$index != tableData.length - 1">
                      <el-link v-if="tableParams1.orderStatus == 2" type="success" :underline="false"
                        @click="workStartEnd(3, scope.row)"> 开工 </el-link>
                    </span>
                    <span
                      v-else-if="item.label == '累计车数' && showAll != 'table_1' && scope.$index != tableData.length - 1">
                      <el-link type="primary" :underline="false" @click="ToViewTypeFun(scope.row,1)"> {{
                        scope.row.cumulativeCar }}{{ scope.row.taskCarNums ? `(${scope.row.taskCarNums})` : '' }}
                      </el-link>
                    </span>
                    <span
                      v-else-if="item.label == '累计方量' || item.label == '累计发料' && showAll != 'table_1' && scope.$index != tableData.length - 1">
                      <span>
                        {{
                          scope.row.cumulativeUseNum }}{{ scope.row.taskNum ? `(${scope.row.taskNum})` : '' }}
                      </span>
                    </span>
                    <span
                      v-else-if="item.label == '在外车辆' && showAll != 'table_1' && scope.$index != tableData.length - 1">
                      <el-popover v-if="scope.row.outCarNos" :key="scope.row.planId" :offset="100" placement="top"
                        :close-delay="100" width="260" trigger="hover">
                        <div class="outCarNos">
                          <span v-for="(carItem, carIndex) in scope.row.outCarNos" :key="carIndex"
                            style="margin-left: 10px">{{ carItem }}</span>
                        </div>
                        <el-link slot="reference" type="warning" style="width: 30px" :underline="false"> {{
                          scope.row.outCarNoCount }} </el-link>
                      </el-popover>
                      <el-link v-else style="width: 30px" type="info" :underline="false">{{ scope.row.outCarNoCount
                      }}</el-link>
                    </span>
                    <span v-else-if="item.label == '状态'">
                      <span v-if="scope.row.taskStatus == 0">取消</span>
                      <span v-else-if="scope.row.taskStatus == 1" style="color:#00b85c;">进行中</span>
                      <span v-else-if="scope.row.taskStatus == 2" style="color: red;">暂停</span>
                      <span v-else-if="scope.row.taskStatus == 3">完成</span>
                      <span v-else>-</span>
                    </span>
                    <div
                      v-else-if="item.label == '发料通知' && showAll != 'table_1' && scope.$index != tableData.length - 1">
                      <el-button size="mini" class="bottom_one" @click="look5_0Fun(scope.row)">查看</el-button>
                      <el-tag v-if="scope.row.planNoticeNum" type="danger" size="mini">{{ scope.row.planNoticeNum
                      }}</el-tag>
                    </div>
                    <span v-else class="ellipsis-text">{{ scope.row[item.prop] }}</span>
                  </template>
                </el-table-column>
              </template>
              </el-table>
            </div>
          </div>
        </div>
      </el-main>
      <div class="card_bottom">
        <div class="card_bottom_left">
          <div class="top_page_totle">总共{{ total }}条</div>
          <el-pagination :current-page.sync="tableParams.page" :page-size="tableParams.pageSize"
            :page-sizes="[10, 20, 30, 40, 50, 100, 200, 500, 1000]" layout="prev,pager,sizes,next,jumper" :total="total"
            @size-change="sizeChange" @current-change="gettableData()"></el-pagination>
        </div>
        <div>
          <el-button size="mini" icon="el-icon-refresh-right" class="bottom_all_two"
            @click="gettableData()">刷新</el-button>
        </div>
      </div>
    </el-container>
<!-- 发料通知 -->
<el-dialog v-dialogDrag :visible.sync="formData5Type" width="1140px" :close-on-click-modal="false">
      <span slot="title" class="dialog-title">发料通知</span>
      <div class="dialoginfo">
        <div class="FZYulli">
          <div style="margin-bottom: 5px">工程名称：{{ formData5.engineeringName }}</div>
          <div style="margin-bottom: 5px">订单编号：{{ formData5.orderNo }}</div>
          <div style="margin-bottom: 5px">产品名称：{{ formData5.productName }}</div>
        </div>
        <el-table :header-cell-style="{ background: '#f3f6f9' }" :cell-style="{ borderRight: 'none' }" border stripe
          style="width: 100%" :data="formData5.list" tooltip-effect="dark">
          <el-table-column label="创建时间" align="center" prop="createTime" width="133"></el-table-column>
          <el-table-column label="创建人" align="center" prop="createUserUame"></el-table-column>
          <el-table-column label="修改人" align="center" prop="updateUserName"></el-table-column>
          <el-table-column label="修改时间" align="center" prop="updateTime"></el-table-column>
          <el-table-column label="计划发料时间" align="center" prop="planStartTime" width="133"></el-table-column>
          <el-table-column label="计划发料量" align="center" prop="theRestNum"></el-table-column>
          <el-table-column label="间隔时间" align="center" prop="sendFrequency"></el-table-column>
          <el-table-column label="产品名" align="center" prop="product"></el-table-column>
          <el-table-column label="任务状态" align="center" prop="taskStatus"></el-table-column>
          <el-table-column label="累计方量" align="center" prop="sumSendNum"></el-table-column>
          <el-table-column label="累计车次" align="center" prop="carNum"></el-table-column>
          <el-table-column label="操作日志" align="center" prop="operateResordList"></el-table-column>
        </el-table>
      </div>
      <div class="card_bottom">
        <div class="card_bottom_left">
          <div class="top_page_totle">总共{{ formData5Param.total }}条</div>
          <el-pagination :current-page.sync="formData5Param.page" :page-size="formData5Param.pageSize"
            :page-sizes="[10, 20, 30, 40, 50, 100, 200, 500, 1000]" layout="prev,pager,sizes,next,jumper"
            :total="formData5Param.total" @size-change="formData5SizeChange"
            @current-change="queryNotepage()"></el-pagination>
        </div>
        <div>
          <el-button size="mini" icon="el-icon-refresh-right" class="bottom_all_two" @click="queryNotepage">刷新</el-button>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button class="bottom_all_two" @click="formData5Type = false">关闭</el-button>
      </span>
    </el-dialog>
    <!-- 累计车辆弹窗 -->
    <carDetail :visible.sync="carDetailDig" :config="low" :printSetData="printSetData" :carType="carType" :isLook="true" />
  </div>
</template>

<script>
import mixin from "@/mixins/ICPSmixin.js";
import { getUserInfo } from "@/utils/auth.js";
import {
  queryPlans,queryNotepage,queryTicketMachineCon
} from "@/api/smart/productTransport_outside.js";
import { getUserAutList } from "@/api/common.js";
import carDetail from "@/views/platform/ICPS/smart/schedul/components/carDetail";
export default {
  mixins: [mixin],
  filters: {
    pouringMethodFilter(e) {
      if (e) {
        e = JSON.parse(e);
        let table = e.map(res => res.name);
        let text = table.join("、");
        return text;
      }
    },
  },
  components: {
    carDetail,
  },
  data() {
    return {
      searchForm: {
        carNo: "", // 车牌号
        orderStatus: "3", // 状态,
        productName: "", // 工程名称，
        proTimeRange: "", // 生产时间
        stationIds:[],
      },
      oderStatusList: [
        {
          value: "2",
          name: "待开工",
        },
        {
          value: "3",
          name: "生产中",
        },
        {
          value: "4",
          name: "已完成",
        },
      ],
      tableLoading: false, // 表格加载
      tableParams: {
        // 表格页参数
        pageSize: 10,
        page: 1,
      },
      total: 0, // 表格数据总条数
      table: [
      ],
      //待开工
      table1_1: [
        // { label: "订单号", prop: "orderNo", status: true, width: "150" },
        { label: "站点名称", prop: "stationName", status: true, width: "70" },
        { label: "生产线", prop: "lineName", status: true, width: "100" },
        { label: "浇筑时间", prop: "pourTime", status: true, width: "135" },
        { label: "客户单位", prop: "customerName", status: true, width: "200" },
        { label: "工程项目", prop: "engineeringName", status: true, width: "auto" },
        { label: "浇筑部位", prop: "structuralParts", status: true, width: "200" },
        { label: "产品名称", prop: "productName", status: true, width: "100" },
        { label: "计划量", prop: "planNum", status: true, width: "60" },
        { label: "浇筑方式", prop: "pouringMethod", status: true, width: "100" },
        { label: "结算方式", prop: "settleMethod", status: true, width: "100" },
        { label: "累计车数", prop: "cumulativeCar", status: true, width: "70" },
        { label: "累计方量", prop: "cumulativeUseNum", status: true, width: "70" },
        { label: "发料通知", prop: "planNoticeNum", status: true, width: "100" },
        { label: "开工", prop: "", status: true, width: "80", fixed: "left" },
      ],
      //生产中
      table1_2: [
        // { label: "发料", prop: "send", status: true, width: "180" },
        // { label: "优先等级", prop: "transportSort", status: true, width: "85", align: "left" },
        { label: "浇筑时间", prop: "pourTime", status: true, width: "135" },
        // { label: "订单号", prop: "orderNo", status: true, width: "150" },
        { label: "站点名称", prop: "stationName", status: true, width: "70" },
        { label: "生产线", prop: "lineName", status: true, width: "100" },
        { label: "客户单位", prop: "customerName", status: true, width: "200" },
        { label: "工程项目", prop: "engineeringName", status: true, width: "auto" },
        { label: "浇筑部位", prop: "structuralParts", status: true, width: "200" },
        { label: "产品名称", prop: "productName", status: true, width: "100" },
        { label: "计划量", prop: "planNum", status: true, width: "60" },
        { label: "浇筑方式", prop: "pouringMethod", status: true, width: "100" },
        { label: "结算方式", prop: "settleMethod", status: true, width: "100" },
        { label: "累计车数", prop: "cumulativeCar", status: true, width: "70" },
        { label: "累计方量", prop: "cumulativeUseNum", status: true, width: "100" },
        { label: "在外车辆", prop: "outCarNoCount", status: true, width: "70" },
        { label: "发料通知", prop: "planNoticeNum", status: true, width: "100" },
      ],
      table1_3: [
        // { label: "订单号", prop: "orderNo", status: true, width: "220" },
        { label: "站点名称", prop: "stationName", status: true, width: "70" },
        { label: "生产线", prop: "lineName", status: true, width: "100" },
        { label: "浇筑时间", prop: "pourTime", status: true, width: "135" },
        { label: "客户单位", prop: "customerName", status: true, width: "200" },
        { label: "工程项目", prop: "engineeringName", status: true, width: "auto" },
        { label: "浇筑部位", prop: "structuralParts", status: true, width: "200" },
        { label: "产品名称", prop: "productName", status: true, width: "140" },
        { label: "计划量", prop: "planNum", status: true, width: "60" },
        { label: "浇筑方式", prop: "pouringMethod", status: true, width: "100" },
        { label: "结算方式", prop: "settleMethod", status: true, width: "100" },
        { label: "累计车数", prop: "cumulativeCar", status: true, width: "70" },
        { label: "累计方量", prop: "cumulativeUseNum", status: true, width: "70" },
        { label: "在外车辆", prop: "outCarNoCount", status: true, width: "70" },
        { label: "发料通知", prop: "planNoticeNum", status: true, width: "100" },
      ],
      tableData: [], // 表格数据

      TransportLookConfig: {},
      TransportLookVisible: false,
      stationList: [],
      columKey:"",
       //发料通知
       formData5Type: false,
      formData5: {},
      formData5Param: {
        page: 1,
        pageSize: 10,
        engId: "",
      },
      carType:1,
      low:{},
      carDetailDig: false,
      printSetData:[],
    };
  },
  async created() {
    this.UserInfo = await getUserInfo();
    this.stationList = await getUserAutList(true);
    console.log(this.stationList);
    this.searchForm.stationIds = []
    if (this.UserInfo.pointIds.length > 0) {
      this.searchForm.stationIds.push(this.UserInfo.pointIds[0])
    } else {
      this.searchForm.stationIds.push(this.stationList[0].id)
    }
    this.getTime();
    this.table = this.table1_2;
        this.showAll = 'table1_2'
    this.gettableData();
  },
  methods: {
    ToViewTypeFun(row, carType) {
      //打票机设置列表
      queryTicketMachineCon({ stationId: row.stationId }).then(res => {
        if (res.code == 1001) {
          this.printSetData = res.data;
        }
      });
      this.low = row;
      this.carDetailDig = true;
      this.carType = carType
    },
     //发料通知
     look5_0Fun(e) {
      this.low = e;
      this.formData5Type = true;
      this.formData5.engineeringName = e.engineeringName;
      this.formData5.orderNo = e.orderNo;
      this.formData5.productName = e.productName;
      this.formData5Param.planId = e.planId
      this.queryNotepage();
    },
    queryNotepage() {
      queryNotepage(this.formData5Param).then(res => {
        this.formData5.list = [];
        this.formData5.list = res.data.data;
        this.formData5Param.total = res.data.totalRows;
      });
    },
    getSummaries(param) {
      const { columns, data } = param;
      const sums = [];
      console.log(columns)
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = '合计';
          return;
        }
        const values = data.map(item => Number(item[column.property]));
        console.log(column.property)
        console.log(values)
        if (!values.every(value => isNaN(value))) {
          sums[index] = values.reduce((prev, curr) => {
            const value = Number(curr);
            if (!isNaN(value)) {
              return prev + curr;
            } else {
              return prev;
            }
          }, 0);
          sums[index] = Number( sums[index]).toFixed(2)
        } else {
          sums[index] = '';
        }
      });
      console.log(sums)
      return sums;
    },
    getNextDay(date) {
      const nextDate = new Date(date);
      nextDate.setDate(date.getDate() + 1);
      return nextDate.toISOString().split("T")[0];
    },
    getYesterdayDate(date) {
      const yesterday = new Date(date);
      yesterday.setDate(yesterday.getDate() - 1);
      return yesterday.toISOString().split("T")[0];
    },
    getTime() {
      this.searchForm.proTimeRange = [];
      this.searchForm.proTimeRange[0] = this.getYesterdayDate(new Date()) + " 00:00:00";
      this.searchForm.proTimeRange[1] = this.getNextDay(new Date()) + " 23:59:59";
    },
    async gettableData() {
      // 获取表格数据
      console.log(this.searchForm);

      let params = { ...this.searchForm, ...this.tableParams };
      if (this.searchForm.proTimeRange) {
        params.pourTime = this.searchForm.proTimeRange[0];
        params.endPourTime = this.searchForm.proTimeRange[1];
      }
      const res = await queryPlans(params);
      if (res.code === 1001) {
        this.tableData = res.data.data;
        this.total = res.data.totalRows;
      }
    },
    //切换订单状态
    changeOrderStatus(item) {
      if (item.value == "2") {
        this.table = this.table1_1;
        this.showAll = 'table1_1'
      } else if (item.value == "3") {
        this.table = this.table1_2;
        this.showAll = 'table1_2'
      } else {
        this.table = this.table1_3;
        this.showAll = 'table1_3'
      }
      this.columKey = Math.random()
      this.gettableData();
      this.$refs.table1.doLayout();
      this.$forceUpdate();
    },
    init() {
      // 重置
      this.searchForm = {
        carNo: "", // 车牌号
        orderStatus: "", // 状态
        structuralParts:"",
        proLine:"",
        productName:"",
        operator:"",
        stationIds:[]
      };
      this.tableParams = {
        // 表格页参数
        pageSize: 10,
        page: 1,
      };
      if (this.UserInfo.pointIds.length > 0) {
      this.searchForm.stationIds.push(this.UserInfo.pointIds[0])
    } else {
      this.searchForm.stationIds.push(this.stationList[0].id)
    }
      this.gettableData();
    },
    sizeChange(value) {
      // 选择显示条数
      this.tableParams.pageSize = value;
      this.gettableData();
    },
    transportLook(row) {
      // 运输查看，点击运输号
      this.TransportLookConfig = {
        id: row.id,
      };
      this.TransportLookVisible = true;
    },
    formData5SizeChange(value) {
      this.formData5Param.pageSize = value;
      this.queryNotepage();
    },
  },
};
</script>
<style lang="scss" scoped>
.ellipsis-text {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.el-table{
        overflow:visible !important;
  }
</style>
